<template>
  <div class="header">
    <div class="link-container">
      <div>
        <SubLink link_style="sub-link" path="/background" text="Background" />
      </div>
    </div>
    <div class="link-container">
      <div>
        <SubLink
          link_style="sub-link"
          path="/publications"
          text="Publications"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SubLink from "./SubLink";

export default {
  name: "Header",
  components: {
    SubLink,
  },
};
</script>

<style scoped>
.header {
  position: fixed;
  left: 360px;
  top: 0;
  display: flex;
  justify-content: left;
  width: 100%;
  height: 90px;
  background-color: #f9f9f9;
  box-shadow: rgba(99, 99, 99, 0.3) 0px 2px 6px 0px;
  z-index: 1;
}
.link-container {
  width: 180px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.link-container > div {
  position: relative;
  height: 30px;
}
@media (max-width: 1000px) {
  div.header {
    display: none;
  }
}
</style>